import {
  IconSectionSoftware1,
  IconSectionSoftware2,
  IconSectionSoftware3,
  IconSectionSoftware4,
} from '@/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionService = () => {
  const { t } = useTranslation();
  const data = [
    {
      number: '01',
      icon: <IconSectionSoftware1 />,
      title: t('Software Development'),
      desc: t(
        'We create custom software solutions that streamline operations and boost efficiency. From enterprise systems to niche applications, our end-to-end development services ensure high performance, security, and seamless integration.'
      ),
    },
    {
      number: '02',
      icon: <IconSectionSoftware2 />,
      title: t('Mobile App Development'),
      desc: t(
        'Engage your users with intuitive and feature-rich mobile apps. We develop cross-platform and native iOS/Android applications, delivering exceptional user experiences for industries like e-commerce, healthcare, and more.'
      ),
    },
    {
      number: '03',
      icon: <IconSectionSoftware3 />,
      title: t('Web App Development'),
      desc: t(
        'Our web applications are fast, secure, and user-friendly, built to meet your unique needs. Whether it’s a SaaS platform, e-commerce site, or internal tool, we ensure robust functionality and modern design.'
      ),
    },
    {
      number: '04',
      icon: <IconSectionSoftware4 />,
      title: t('Game Development'),
      desc: t(
        'Bring immersive gaming experiences to life with our game development expertise. We craft engaging 2D/3D games for mobile, web, and desktop, leveraging cutting-edge technologies to captivate players worldwide.'
      ),
    },
  ];
  return (
    <div className="section-software-services">
      <p className="label-section">[{t('Software Development Service')}]</p>
      <div className="list-service">
        {data.map((item) => (
          <div key={item.number} className="item">
            <p className="number">{item.number}</p>
            <div>{item.icon}</div>
            <div>
              <p className="title">{item.title}</p>
              <p className="desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(SectionService);
